import { render, staticRenderFns } from "./DeleteAccountBank.vue?vue&type=template&id=72489173&scoped=true"
import script from "./DeleteAccountBank.vue?vue&type=script&lang=js"
export * from "./DeleteAccountBank.vue?vue&type=script&lang=js"
import style0 from "./DeleteAccountBank.vue?vue&type=style&index=0&id=72489173&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72489173",
  null
  
)

export default component.exports